module.exports = __webpack_public_path__ + "media/images/CGV-3a691596.jpeg";